<style scoped>
.pdd {
  margin: 0 80px;
}
</style>

<template lang="pug">
    form.pdd
      .row
        .col.s12#actions
      .row
        //- pre {{reseller.businessinfo[0]}}
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].storeName !== "null"') {{reseller.businessinfo[0].storeName}}
            label.active(for='name') Store Name :
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].storeAddress !== "null"') {{reseller.businessinfo[0].storeAddress}}
            label.active(for='name') Store Address :
      .row
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].businessName !== "null"') {{reseller.businessinfo[0].businessName}}
            label.active(for='name') Business Name :
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].mainOfficeAddress !== "null"') {{reseller.businessinfo[0].mainOfficeAddress}}
            label.active(for='name') Main Office Address :
      .row
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].storeTelNo !== "null"') {{reseller.businessinfo[0].storeTelNo}}
            label.active(for='name') Store Tel No :
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].businessTelNo !== "null"') {{reseller.businessinfo[0].businessTelNo}}
            label.active(for='name') Business Tel No :
      .row
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].typeOfOrganization !== "null"') {{reseller.businessinfo[0].typeOfOrganization}}
            label.active(for='name') Type Of Organization :
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].yearsOfOperation !== "null"') {{reseller.businessinfo[0].yearsOfOperation}}
            label.active(for='name') Years Of Operation :
      .row
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].tinNo !== "null"') {{reseller.businessinfo[0].tinNo}}
            label.active(for='name') Tin Number :
        .col.s12.m6.input-field
            span(v-if='reseller.businessinfo[0].secRegNo !== "null"') {{reseller.businessinfo[0].secRegNo}}
            label.active(for='name') sec Reg No :

</template>
<script>
export default {
  props: ['reseller']
};
</script>



// WEBPACK FOOTER //
// src/components/app-reseller-business-details.vue